import { MDBIcon, MDBInput } from "mdb-react-ui-kit";
import { useContext } from "react";
import useResumeHobbiesHandlers from "../../../context/resume/hooks/resume-hobbies-handlers";
import { TranslationContext } from "../../../context/translations/translations-context";

export default function HobbyItem(
    {
        item,
        numberOfItems,
    } ) {
    const { translations } = useContext(TranslationContext);
    const { handleChange, handleRemove, handleMoveUp, handleMoveDown } = useResumeHobbiesHandlers();

    return (
        <div>
            <div className="d-flex align-items-center gap-1 mt-2">
                <MDBInput
                    className="form-control-input"
                    type="text"
                    value={ item.text || "" }
                    onChange={ event => {
                        handleChange( {
                            ...item,
                            text: event.target.value
                        } );
                    } }
                />
                <div className="d-flex align-items-center">
                    <MDBIcon
                        fas
                        icon="arrow-up"
                        className="m-1"
                        onClick={ () => item.order !== 0 && handleMoveUp( item ) }
                        style={ { cursor: item.order !== 0 ? "pointer" : "default" } }
                        color={ item.order !== 0 ? "" : "muted" }
                        role="button"
                        title="Remonter"
                    />
                    <MDBIcon
                        fas
                        icon="arrow-down"
                        className="m-1"
                        onClick={ () => item.order !== numberOfItems - 1 && handleMoveDown( item ) }
                        style={ { cursor: item.order !== numberOfItems - 1 ? "pointer" : "default" } }
                        color={ item.order !== numberOfItems - 1 ? "" : "muted" }
                        role="button"
                        title="Descendre"
                    />
                </div>
                <MDBIcon
                    far
                    icon="trash-alt"
                    className="m-1 text-end text-white"
                    onClick={ () =>  window.confirm(translations.general.confirmationMessage) && handleRemove( item ) }
                    role="button"
                    size="lg"
                />
            </div>
        </div>
    );
};
